import {
    API_ATTENDANCE_LIST,
    API_WORKTIME_LIST,
    API_WORKTIME_DELETE,
    API_WORKTIME_UPDATE,
    API_APPEAL_LIST,
    API_APPEAL_REJECT,
    API_APPEAL_PASS,
    API_MAP_SUGGESTIONSEARCH,
    API_MAP_CONTRARYCONVERTGEOCODER
} from '@/common/constants';
import {
    get,
    post,
    del
    // put
} from '@/utils/http';

export const queryClockInfoList = (params) => {
    return post(API_ATTENDANCE_LIST, params);
};

export const getWorkTimeList = (params) => {
    return get(API_WORKTIME_LIST, params);
};

export const delWorkTime = (id) => {
    return del(API_WORKTIME_DELETE.replace(':id', id));
};

export const updateWorkTime = (params) => {
    return post(API_WORKTIME_UPDATE, params);
};

export const getAppealClockList = (params) => {
    return get(API_APPEAL_LIST, params);
};

export const passAppeal = (params) => {
    return post(API_APPEAL_PASS, params);
};

export const rejectAppeal = (params) => {
    return post(API_APPEAL_REJECT, params);
};

export const suggestionSearch = (params) => {
    return post(API_MAP_SUGGESTIONSEARCH, params);
};

export const contraryConvertGeocoder = (params) => {
    return post(API_MAP_CONTRARYCONVERTGEOCODER, params);
};

// export const getDepartmentTreeList = (rootId) => {
//     return get(API_DEPARTMENT_TREE_LIST, rootId ? { rootId } : {});
// };

// export const getDepartmentDetail = (departmentId) => {
//     return get(API_DEPARTMENT_DETAIL.replace(':departmentId', departmentId));
// };

// export const delDepartment = (departmentId) => {
//     return del(API_DEPARTMENT_DELETE.replace(':departmentId', departmentId));
// };

// export const saveDepartment = (department) => {
//     if (department.id === undefined || department.id === '') { // 新增
//         return post(API_DEPARTMENT_SAVE, department);
//     } else { // 修改
//         return put(API_DEPARTMENT_SAVE, department);
//     }
// };



// WEBPACK FOOTER //
// ./src/data-model/office/attendance-model.js